import { IdSchema } from "@hisani/core";
import { z } from "zod";
export const MARKETPLACE_ERROR_CODES = {
    conflict: "MARKETPLACE_CONFLICT",
    forbidden: "MARKETPLACE_FORBIDDEN",
    invalidRequest: "MARKETPLACE_INVALID_REQUEST",
    invalidTransition: "MARKETPLACE_INVALID_TRANSITION",
    notFound: "MARKETPLACE_NOT_FOUND",
    unavailable: "MARKETPLACE_UNAVAILABLE",
    uploadUnavailable: "MARKETPLACE_UPLOAD_UNAVAILABLE",
    invalidUpload: "MARKETPLACE_UPLOAD_INVALID",
};
export const MarketplaceBreedSchema = z.enum([
    "THOROUGHBRED",
    "PUREBRED_ARABIAN",
    "OTHER",
]);
export const MarketplaceSexSchema = z.enum([
    "COLT",
    "FILLY",
    "GELDING",
    "MARE",
    "STALLION",
]);
export const MarketplacePricingTypeSchema = z.enum([
    "EXACT",
    "RANGE",
    "CONTACT",
]);
export const MarketplaceListingStatusSchema = z.enum([
    "PENDING",
    "APPROVED",
    "REJECTED",
    "SOLD",
    "WITHDRAWN",
    "EXPIRED",
    "REMOVED",
]);
export const MarketplaceAssetKindSchema = z.enum([
    "PHOTO",
    "VIDEO",
    "VET_DOCUMENT",
]);
export const MarketplaceUploadKindSchema = z.enum([
    "PHOTO",
    "VIDEO",
    "VET_DOCUMENT",
    "SCAN_IMAGE",
]);
export const MarketplaceSortSchema = z.enum([
    "NEWEST",
    "PRICE_ASC",
    "PRICE_DESC",
]);
export const MarketplaceOutboxEventTypeSchema = z.enum([
    "MARKETPLACE_LISTING_APPROVED",
    "MARKETPLACE_LISTING_REJECTED",
    "MARKETPLACE_LISTING_REMOVED",
    "MARKETPLACE_LISTING_EXPIRED",
    "MARKETPLACE_LISTING_REPORTED",
    "MARKETPLACE_MESSAGE_RECEIVED",
]);
export const MarketplaceOutboxEventSchema = z
    .object({
    id: IdSchema,
    type: MarketplaceOutboxEventTypeSchema,
    occurredAt: z.date(),
})
    .strict();
export const MarketplacePolicySchema = z.object({
    listingExpiryDays: z.number().int().min(1).max(365),
    maximumPhotos: z.number().int().min(1).max(20),
    maximumVideos: z.number().int().min(0).max(10),
    maximumVetDocuments: z.number().int().min(0).max(20),
});
export const DEFAULT_MARKETPLACE_POLICY = MarketplacePolicySchema.parse({
    listingExpiryDays: 90,
    maximumPhotos: 8,
    maximumVideos: 4,
    maximumVetDocuments: 4,
});
export const MARKETPLACE_UPLOAD_STATE_TAG = "hisani-marketplace-state";
export const MARKETPLACE_UPLOAD_PENDING_STATE = "pending";
export const MARKETPLACE_UPLOAD_CLAIMED_STATE = "claimed";
export const MARKETPLACE_UPLOAD_MAX_AGE_MS = 23 * 60 * 60 * 1_000;
export const MARKETPLACE_UPLOAD_CLEANUP_AGE_MS = 24 * 60 * 60 * 1_000;
export const MarketplaceHorseScanKindSchema = z.enum([
    "HORSE_PASSPORT",
    "HORSE_NAME_TAG",
]);
export const MARKETPLACE_HORSE_SCAN_FIELD_NAMES = [
    "horseName",
    "breed",
    "breedOther",
    "dateOfBirth",
    "sex",
    "sire",
    "dam",
];
